export default __webpack_public_path__ + "static/media/Grid.5cef8f37.svg";